import { render, staticRenderFns } from "./SpareCatalog.vue?vue&type=template&id=486ad0b8&scoped=true"
import script from "./SpareCatalog.vue?vue&type=script&lang=js"
export * from "./SpareCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486ad0b8",
  null
  
)

export default component.exports